import { mapGetters } from "vuex";

import UserAvatar from "@/components/UserAvatar";
import UserPhoneControl from "@/components/UserPhoneControl";
import UserEmailControl from "@/components/UserEmailControl";
import UserPasswordControl from "@/components/UserPasswordControl";
import UserPreferencesControl from "./components/UserPreferencesControl";

import Multiselect from "vue-multiselect";

import { required, minLength, maxLength } from "vuelidate/lib/validators";

import {
  UPDATE_USER_PROFILE_INFO,
  SIGN_OUT,
  PLACES_SUGGESTIONS,
  DELETE_USER,
  REFUSE_TO_BE_LEAD,
} from "../gql/UserProfileQueries";

export default {
  name: "user_profile_info",

  data() {
    return {
      submitProfileInfoLoading: false,

      userInfo: {},

      submitSingOut: false,
      profileInfo: "",

      skiplocationsQuery: true,
      isLocationsLoading: false,

      submitIsPublicBuyer: false
    };
  },

  validations: {
    userInfo: {
      firstName: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(64)
      },
      lastName: {
        minLength: minLength(1),
        maxLength: maxLength(64)
      },
      aboutMe: {
        maxLength: maxLength(400)
      }
    }
  },

  apollo: {
    places: {
      query: PLACES_SUGGESTIONS,
      variables() {
        return {
          address: this.locationRequestQuery
        };
      },

      skip() {
        return this.skiplocationsQuery;
      },

      result() {
        this.skiplocationsQuery = true;
        this.isLocationsLoading = false;
      }
    }
  },

  computed: {
    ...mapGetters({
      currentUser: "getUser"
    }),

    isUserLoaded() {
      return !!this.userInfo.id;
    },

    filteredLocationOptions() {
      const filtered = [];

      if (!this.places) {
        return [];
      }

      this.places.forEach(r => {
        filtered.push({
          type: r.type,
          places: r.places,
          limit: 8,
          onSelected: selected => {
            this.selected = selected.item;
          }
        });
      });

      return Object.freeze(filtered);
    }
  },

  mounted: function() {
    if (this.currentUser.id) {
      this.userInfo = JSON.parse(JSON.stringify(this.currentUser));
    }
  },

  watch: {
    currentUser: function(newValues) {
      this.userInfo = JSON.parse(JSON.stringify(newValues));
    }
  },

  methods: {
    asyncFindLocations(query) {
      if (query.length > 2) {
        this.locationRequestQuery = query;
        this.skiplocationsQuery = false;

        this.isLocationsLoading = true;
      }
    },

    submitProfileInfo() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.submitProfileInfoLoading = true;

        this.$apollo
          .mutate({
            mutation: UPDATE_USER_PROFILE_INFO,
            variables: {
              firstName: this.userInfo.firstName,
              lastName: this.userInfo.lastName,
              aboutMe: this.userInfo.aboutMe
            }
          })
          .then(({ data: { updateProfile: { user } } }) => {
            this.$store.commit("setUserInfo", user);
          })
          .catch(mutationError => {
            const errors = mutationError.graphQLErrors;

            for (let error in errors) {
              this.$toasted.error(errors[error].message);
            }
          })
          .finally(() => {
            this.submitProfileInfoLoading = false;
          });
      }
    },

    updateTcpaAccepted() {
      this.$apollo
        .mutate({
          mutation: UPDATE_USER_PROFILE_INFO,
          variables: {
            tcpaAccepted: this.userInfo.tcpaAccepted
          }
        })
        .then(({ data: { updateProfile: { user } } }) => {
          this.$store.commit("setUserInfo", user);
        })
        .catch(mutationError => {
          const errors = mutationError.graphQLErrors;
          for (let error in errors) {
            this.$toasted.error(errors[error].message);
          }
        });
    },

    signOutRequest(isDeleteRequest) {
      let type = SIGN_OUT;

      if (isDeleteRequest) {
        type = DELETE_USER;
      }

      this.$apollo
        .mutate({
          mutation: type
        })
        .then(() => {
          this.$store.dispatch("destroyUser");

          this.$router.push({
            name: "home"
          });
        })
        .catch(mutationError => {
          const errors = mutationError.graphQLErrors;

          for (let error in errors) {
            this.$toasted.error(errors[error].message);
          }
        })
        .finally(() => {
          this.submitSingOut = false;
        });
    },

    signOut() {
      if (confirm("Do you really want to sign out?")) {
        this.submitSingOut = true;

        this.signOutRequest();
      }
    },

    hideModal() {
      this.$refs.modalDeleteAccount.hide();
    },

    removeAccount() {
      this.hideModal;
      this.signOutRequest(true);
    },

    updateIsPublicBuyer() {
      this.submitIsPublicBuyer = true;

      this.$apollo
        .mutate({
          mutation: REFUSE_TO_BE_LEAD,
          variables: {
            value: this.userInfo.refusedToBeLead
          }
        })
        .catch(mutationError => {
          const errors = mutationError.graphQLErrors;

          for (let error in errors) {
            this.$toasted.error(errors[error].message);
          }
        })
        .finally(() => {
          this.submitIsPublicBuyer = false;
        });
    }
  },

  components: {
    UserAvatar,
    UserPreferencesControl,
    UserPhoneControl,
    UserEmailControl,
    UserPasswordControl,
    Multiselect
  }
};
